import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createFetchChampionshipsReducer, createPagedChampionshipsReducers } from 'modules/tournaments/store/tournaments/reducers';
import { Championship } from 'modules/tournaments/domain/interfaces/responce-dto';
import type { PagedDictionary } from 'shared/utils/pagination';

export interface TournamentsSliceState {
  isLoading: boolean;
  isLoaded: boolean;

  // Линейный массив (оставлен для обратной совместимости, сейчас не используется напрямую)
  championships: Championship[];

  // TODO: check and maybe remove
  // Универсальный ленивый постраничный кэш для championships
  paged: {
    championships: PagedDictionary<Championship>;
    loadingByScope: Record<string, boolean>;
    errorByScope: Record<string, string | undefined>;
  };
}

const initialState: TournamentsSliceState = {
  isLoading: false,
  isLoaded: false,

  championships: [],

  paged: {
    championships: { byId: {}, scopes: {} },
    loadingByScope: {},
    errorByScope: {},
  },
};

export const tournamentsSlice = createSlice({
  name: 'tournaments',
  initialState,
  reducers: {
    // сброс кэша конкретного scope при необходимости
    resetChampionshipsScope(state, action: PayloadAction<{ scopeKey: string }>) {
      const key = action.payload.scopeKey;
      delete state.paged.championships.scopes[key];
      // данные в byId не чистим намеренно (могут переиспользоваться)
      delete state.paged.loadingByScope[key];
      delete state.paged.errorByScope[key];
    },
  },
  extraReducers: (builder) => {
    createFetchChampionshipsReducer(builder);
    createPagedChampionshipsReducers(builder);
  },
});

export const { resetChampionshipsScope } = tournamentsSlice.actions;

export default tournamentsSlice.reducer;
